import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHashTarget } from "@/lib/scrollToHash";

const RETRY_DELAY = 80;
const MAX_ATTEMPTS = 18;

const forceScrollTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // Reset immediately
      forceScrollTop();
      // Reset again after Lenis may have initialized and overridden position
      const t1 = window.setTimeout(forceScrollTop, 50);
      const t2 = window.setTimeout(forceScrollTop, 150);
      return () => {
        window.clearTimeout(t1);
        window.clearTimeout(t2);
      };
    }

    let attempts = 0;
    let retryTimer: number | undefined;
    let settleTimer: number | undefined;

    const tryScroll = () => {
      attempts += 1;
      const didScroll = scrollToHashTarget(hash, attempts === 1 ? "auto" : "smooth");

      if (didScroll) {
        settleTimer = window.setTimeout(() => {
          scrollToHashTarget(hash, "auto");
        }, 220);
        return;
      }

      if (attempts < MAX_ATTEMPTS) {
        retryTimer = window.setTimeout(tryScroll, RETRY_DELAY);
      }
    };

    tryScroll();

    return () => {
      if (retryTimer) window.clearTimeout(retryTimer);
      if (settleTimer) window.clearTimeout(settleTimer);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
